module.exports = __webpack_public_path__ + "img/404.2b1096fe.svg";